<template>
  <DsFeaturesSection
    eyebrow="Características generales"
    title-base="Formas de liquidación"
    title-highlight="disponibles"
    title-id="liquidacion-features-title"
    title-base-color="var(--ds-purple-900)"
    title-highlight-color="var(--ds-purple-400)"
    card-layout="centered"
    :columns="2"
    :features="features"
    class="liquidacion-features"
  />
</template>

<script setup lang="ts">
import partialPaymentIcon from '../../../../../assets/liquidacion/liquidacion-partial.svg'
import totalPaymentIcon from '../../../../../assets/liquidacion/liquidacion-total.svg'
import DsFeaturesSection from '../components/DsFeaturesSection.vue'

const features = [
  {
    id: 'total-payment',
    iconSrc: totalPaymentIcon,
    title: 'Liquidación Total',
    description:
      'Paga todas las cuotas pendientes en tus contratos para liquidar por ' +
      'completo tu financiamiento y liberar tu hipoteca.'
  },
  {
    id: 'partial-payment',
    iconSrc: partialPaymentIcon,
    title: 'Liquidación Parcial',
    description:
      'Si cuentas con 2 o más contratos activos, puedes pagar todas las ' +
      'cuotas de uno o más de ellos para reducir tu pago mensual.'
  }
]
</script>

<style scoped>
.liquidacion-features :deep(.ds-chip) {
  padding: 4px 8px;
}

@media (min-width: 768px) {
  .liquidacion-features :deep(.ds-feature-card) {
    min-height: 153px;
  }
}

@media (min-width: 1208px) {
  .liquidacion-features :deep(.ds-feature-card) {
    min-height: 136px;
  }
}
</style>
